export default __webpack_public_path__ + "static/media/pxec.7dcf8db3.png";